(function () {
  var PARTS = ['emitter', 'grip', 'switch', 'pommel'];
  var modules = {};
  var engine = null;

  function b64(str) { return btoa(unescape(encodeURIComponent(str))); }
  function abs(u) { return new URL(u, location.href).href; }
  function find(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }

  // chargement ES module via <script type="module"> (le minificateur Shopify réécrit les imports dynamiques)
  function loadModule(url) {
    if (modules[url]) return modules[url];
    modules[url] = new Promise(function (resolve, reject) {
      var id = '__cdsPdpMod' + Math.random().toString(36).slice(2);
      var timer = setTimeout(function () { delete window[id]; reject(new Error('Module timeout ' + url)); }, 30000);
      window[id] = function (m) { clearTimeout(timer); delete window[id]; resolve(m); };
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = 'import * as M from ' + JSON.stringify(url) + '; window[' + JSON.stringify(id) + '](M);';
      document.head.appendChild(s);
    });
    return modules[url];
  }
  function loadEngine(cfg) {
    if (!engine) {
      engine = (window.__CDS_THREE ? Promise.resolve(window.__CDS_THREE) : loadModule(abs(cfg.three)))
        .then(function (T) { window.__CDS_THREE = T; return loadModule(abs(cfg.bundle)); });
    }
    return engine;
  }
  function whenNear(el, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { io.disconnect(); fn(); }
    }, { rootMargin: '500px 0px' });
    io.observe(el);
  }

  function init(root) {
    if (root.__cdsPdp) return;
    var cfg = JSON.parse(root.querySelector('[data-pdp-config]').textContent);
    var state = { parts: {}, colors: {}, blade: cfg.blade || '#2f8bff', core: 'rgb' };
    var apis = [];
    var nodes = [root];
    root.__cdsPdp = { state: state, apis: apis };

    // pièces : métachamps du produit (« Couronne (E313) ») sinon valeurs par défaut
    PARTS.forEach(function (r) {
      var raw = (cfg.mapped && cfg.mapped[r]) || '';
      var m = String(raw).match(/E\d{3}/);
      var id = m && find(cfg.catalogue[r], m[0]) ? m[0] : cfg.defaults.parts[r];
      var allowed = find(cfg.catalogue[r], id).colors;
      var c = cfg.defaults.colors[r];
      state.parts[r] = id;
      state.colors[r] = allowed.indexOf(c) >= 0 ? c : allowed[0];
    });

    function link() {
      var design = { emitter: state.parts.emitter, grip: state.parts.grip, 'switch': state.parts['switch'], pommel: state.parts.pommel,
        colorMap: Object.assign({}, state.colors), core: state.core };
      return cfg.configurator + '&design=' + encodeURIComponent(b64(JSON.stringify(design)));
    }
    function refreshLinks() {
      var href = link();
      nodes.forEach(function (n) { n.querySelectorAll('[data-cds-link]').forEach(function (a) { a.href = href; }); });
    }
    function setTint(hex) {
      nodes.forEach(function (n) { n.style.setProperty('--forge-tint', hex); });
    }

    function mount3D(el, interactive, view) {
      if (!el) return;
      whenNear(el, function () {
        loadEngine(cfg).then(function (mod) {
          if (!el.isConnected) return;
          var names = {};
          PARTS.forEach(function (r) { cfg.catalogue[r].forEach(function (m) { names[m.id] = m.name; }); });
          var c = Object.assign({}, cfg, { names: names, interactive: interactive, view: view,
            defaults: { parts: state.parts, colors: state.colors, blade: state.blade, core: state.core } });
          apis.push(mod.mount(el, c));
        }).catch(function (err) { console.error('CDS PDP', err); el.classList.add('is-fallback'); });
      });
    }

    // 1. carte sous le bouton d'achat
    var ctaTpl = root.querySelector('template[data-pdp-cta]');
    if (ctaTpl && !document.querySelector('[data-cds-pdp-cta]')) {
      var card = ctaTpl.content.firstElementChild.cloneNode(true);
      card.style.setProperty('--forge-tint', state.blade);
      card.style.setProperty('--forge-accent', root.style.getPropertyValue('--forge-accent'));
      var buy = document.querySelector('.product__info-blocks .buy-buttons-block') || document.querySelector('product-form');
      if (buy) buy.insertAdjacentElement('afterend', card); else root.insertBefore(card, root.firstChild);
      nodes.push(card);
    }

    // 2. vignette 3D en fin de galerie
    var slideTpl = root.querySelector('template[data-pdp-slide]');
    var list = document.querySelector('.product__media-wrapper ul.product__media-list') || document.querySelector('ul.product__media-list');
    if (slideTpl && list && !list.querySelector('.cds-pdp-slide')) {
      var li = slideTpl.content.firstElementChild.cloneNode(true);
      var first = list.querySelector('li.product__media-item');
      if (first) {
        var r = first.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) li.style.setProperty('--cds-ratio', (r.width / r.height).toFixed(4));
      }
      li.style.setProperty('--forge-tint', state.blade);
      list.appendChild(li);
      nodes.push(li);
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      mount3D(li.querySelector('[data-forge-root]'), false, { z: 16, fov: 30, x: -0.2, y: 0.6 });
    }

    // 3. bloc compact
    var band = root.querySelector('.cds-pdp__band');
    if (band) {
      var chips = band.querySelector('[data-cds-blades]');
      var label = band.querySelector('[data-cds-blade-label]');
      var blades = cfg.blades.slice();
      if (!blades.some(function (b) { return b.hex.toLowerCase() === state.blade.toLowerCase(); })) blades.unshift({ label: 'Ce modèle', hex: state.blade });
      var renderChips = function () {
        chips.innerHTML = blades.map(function (b) {
          var on = b.hex.toLowerCase() === state.blade.toLowerCase();
          if (on && label) label.textContent = b.label;
          return '<button type="button" class="cds-forge__blade" data-blade="' + b.hex + '" aria-pressed="' + on + '" aria-label="Lame ' + b.label + '" style="--c:' + b.hex + '"></button>';
        }).join('');
      };
      renderChips();
      chips.addEventListener('click', function (e) {
        var b = e.target.closest('[data-blade]'); if (!b) return;
        state.blade = b.dataset.blade;
        setTint(state.blade);
        apis.forEach(function (a) { a.blade(state.blade); });
        renderChips();
      });
      var count = PARTS.reduce(function (acc, r) {
        return acc * cfg.catalogue[r].reduce(function (s, m) { return s + m.colors.length; }, 0);
      }, 1);
      var countEl = band.querySelector('[data-cds-count]');
      if (countEl) countEl.textContent = count.toLocaleString('fr-FR');
      mount3D(band, true);
    }

    // le thème peut re-générer la fiche (changement de variante) : on ré-insère carte et vignette
    if ('MutationObserver' in window && (card || li)) {
      new MutationObserver(function () {
        if (card && !card.isConnected) {
          var b2 = document.querySelector('.product__info-blocks .buy-buttons-block') || document.querySelector('product-form');
          if (b2) b2.insertAdjacentElement('afterend', card);
        }
        if (li && !li.isConnected) {
          var l2 = document.querySelector('.product__media-wrapper ul.product__media-list') || document.querySelector('ul.product__media-list');
          if (l2) l2.appendChild(li);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    refreshLinks();
  }

  function initAll() { document.querySelectorAll('[data-cds-pdp]').forEach(init); }
  if (!window.__cdsPdpInit) {
    window.__cdsPdpInit = initAll;
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', function (e) {
      var r = e.target.querySelector && e.target.querySelector('[data-cds-pdp]');
      if (!r || !r.__cdsPdp) return;
      r.__cdsPdp.apis.forEach(function (a) { a.dispose(); });
      document.querySelectorAll('[data-cds-pdp-cta], .cds-pdp-slide').forEach(function (n) { n.remove(); });
    });
  }
  initAll();
})();